import Notices                           from "../../../domain/notice/Notices";
import { ACTION_TYPE, GetNoticesAction } from "./NoticeAction";

const noticeReducer = (state: Notices = new Notices(), action: GetNoticesAction): Notices => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.GET_NOTICES:
      return action.notices;
  }
};

export default noticeReducer;
